// FormCreateTopping.jsx
import React from "react";
import { useForm } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../styles/Admin.css";

const FormCreateTopping = ({ handleCreateTopping }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    handleCreateTopping(data);
  };

  return (
    <div className="container">
      <div className="topping-form-container mx-auto">
        <h3 className="text-center fw-bold products-title ">
          Crear Nuevo Topping
        </h3>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <label className="form-label">Nombre del topping</label>
            <input
              type="text"
              className={`form-control ${errors.topping_name ? "is-invalid" : ""}`}
              placeholder="Ejemplo: Bacon, Cebolla, Salsa BBQ, etc."
              {...register("topping_name", {
                required: "Este campo es obligatorio",
              })}
            />
            <div className="invalid-feedback" style={{ minHeight: "20px" }}>
              {errors.topping_name?.message || ""}
            </div>
          </div>
          <button type="submit" className="btn products-btn w-100">
            Crear Topping
          </button>
        </form>
      </div>
    </div>
  );
};

export default FormCreateTopping;
